export default class Setting {
  key!: string | null;
  value!: string | null;

  constructor() {
    this.key = null;
    this.value = null;
  }
}
